/**
 * İstemci olaylarını sunucuya bildir (2026-10-12).
 *
 * Kullanıcı "beni dışarı attı / giriş yapamıyorum" dediğinde sebebi görebilmek için: zorunlu çıkış (sebep kodu),
 * oturum doğrulamanın geçici hatası, giriş zaman aşımı, sunucu 5xx/ağ hataları, yakalanmamış JS hataları.
 * Sistem Yönetimi > Sistem Sağlığı bu kayıtları gösterir. Gönderim bloklamaz, hata fırlatmaz; aynı olay türü
 * dakikada en fazla birkaç kez gider (bozuk bir döngü sunucuyu boğmasın).
 */
const SINIR_DK = 5;
const _sayac = {};

export function olayBildir(tur, detay = {}) {
  try {
    const dk = Math.floor(Date.now() / 60000);
    const anahtar = `${tur}:${dk}`;
    _sayac[anahtar] = (_sayac[anahtar] || 0) + 1;
    if (_sayac[anahtar] > SINIR_DK) return;
    const govde = JSON.stringify({
      tur,
      detay,
      sayfa: window.location.pathname,
      email: localStorage.getItem('email') || '',
      firma: localStorage.getItem('firma') || '',
      zaman: new Date().toISOString(),
      tarayici: navigator.userAgent,
    });
    const url = `${process.env.REACT_APP_BACKEND_URL || ''}/api/sistem/istemci-olay`;
    if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([govde], { type: 'application/json' }))) return;
    fetch(url, { method: 'POST', body: govde, headers: { 'Content-Type': 'application/json' }, keepalive: true })
      .catch(() => {});
  } catch (_) { /* bildirim asla uygulamayı bozmaz */ }
}

/** JWT gövdesini çöz (imza doğrulamaz — yalnız sunucuya ulaşılamadığında ekranı açık tutmak için). */
export function tokenGovdesi(token) {
  try {
    const parca = String(token || '').split('.')[1];
    if (!parca) return null;
    const json = atob(parca.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decodeURIComponent(escape(json)));
  } catch (_) {
    return null;
  }
}
